module.exports = __webpack_public_path__ + "screen3.png?dd81e28b06dac8454817bbab451ab6b2";